import { useEffect, useState } from "react";
import { useAppSelector } from "../store/hooks";
import { formatAmount } from "./format";
import { getDollarExchangeRate } from "../services/currencyServices";

export type Currency = "USD" | "BS";
export type CurrencyExchange = {
  symbol: string;
  exchange: number;
};
export type CurrencyExchanges = {
  [key in Currency]: CurrencyExchange;
};

export const useCurrencyExchanges = (date?: string) => {
  const dollarExchange = 1;
  const [bsExchange, setBsExchange] = useState(
    useAppSelector((state) => state.inmutable.exchangeRate).exchangeRate
  );

  useEffect(() => {
    if (!date) {
      return;
    }

    const afunction = async () => {
      const response = await getDollarExchangeRate(date);

      if (response && response.model) {
        setBsExchange(response.model);
      }
    };

    afunction();
  }, [date]);

  const result: CurrencyExchanges = {
    USD: {
      symbol: "$",
      exchange: dollarExchange,
    },
    BS: {
      symbol: "Bs",
      exchange: bsExchange,
    },
  };

  return result;
};

export const currencyExchange = (
  amount: number,
  exchanges: CurrencyExchanges,
  to: Currency,
  from: Currency = "BS"
): number => {
  const exchange = exchanges[to].exchange / exchanges[from].exchange;
  return amount * exchange;
};

export const currencyExchangeText = (
  amount: number,
  exchanges: CurrencyExchanges,
  to: Currency,
  from: Currency = "BS"
): string => {
  let realAmount = currencyExchange(amount, exchanges, to, from);
  if (realAmount < 0.01 && realAmount > -0.01) {
    realAmount = 0;
  }
  const result = formatAmount(realAmount);

  const symbol = exchanges[to].symbol;

  return `${symbol} ${result}`;
};
